import styled from 'styled-components';
import { Section } from './Section';

export const CallToActionButton = styled.div`
  position: absolute;
  left: 50%;
  bottom: 150px;
  width: 320px;
  transform: translateX(-50%);
`;

export const CallToAction = Section.extend`
  position: relative;

  ${CallToActionButton} {
    top: 60%;
    bottom: auto;
  }
`;
